<template>
  <el-dialog :visible.sync="value" class="editDialog" :title="title" :close-on-click-modal="false" @close="close" @open="getOpen">
    <el-form :model="detail" class="addDetail" :rules="rules" ref="detail" label-width="100px">
      <el-form-item label="消防系统" prop="fireControlSystem">
        <el-select :popper-append-to-body="false" v-model="detail.fireControlSystem" placeholder="请选择消防系统" clearable @change="selectSystem">
          <el-option v-for="item in systemList" :key="item.id" :label="item.name" :value="item.name"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="消防设施" prop="maintenanceContentId">
        <el-select :popper-append-to-body="false" v-model="detail.maintenanceContentId" placeholder="请选择消防设施" clearable @change="changeContent">
          <el-option v-for="item in contentArr" :key="item.id" :label="item.patrolContent" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="设施数量" prop="number">
        <el-input placeholder="请输入设施数量" v-model.number="detail.number" maxlength="200">
        </el-input>
      </el-form-item>
    </el-form>
    <p style="margin-top: 30px; display: flex; justify-content: flex-end">
      <button class='w_next_button cancelButton' @click.prevent="cancel">取消</button>
      <button class='w_next_button confirmButton' style="margin-left: 20px" @click.prevent="confirm">确认</button>
    </p>
  </el-dialog>
</template>

<script>
export default {
  name: 'facilitiesDialog',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    status: {
      type: String,
      default: 'adding'
    },
    data: {
      type: Object,
      default() {
        return {}
      }
    },
    selectBuilding: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      rules: {
        fireControlSystem: [
          { required: true, message: '请选择消防系统', trigger: 'change' }
        ],
        maintenanceContentId: [
          {
            required: true,
            message: '请选择消防设施',
            trigger: ['blur', 'change']
          }
        ],
        number: [
          { required: true, message: '请输入设施数量', trigger: 'blur' },
          { type: 'number', message: '设施数量必须为数字值' }
        ]
      },
      detail: {},
      systemList: [],
      contentArr: [],
      visible: this.value
    }
  },
  watch: {
    value(val) {
      this.setCurrentValue(val)
    },
    visible(value) {
      this.$emit('input', value)
    }
  },
  computed: {
    title() {
      if (this.status == 'adding') {
        return '新增消防设施'
      } else if (this.status == 'editing') {
        return '编辑消防设施'
      }
    }
  },
  methods: {
    setCurrentValue(val) {
      let data = this.data
      if (val) {
        this.getSystemList()
      }
      if (this.status == 'editing') {
        this.detail = data
        this.$axiosget('extra/maintenanceContentItem/getListByFireSystem', {
          params: {
            fireControlSystem: this.detail.fireControlSystem
          }
        }).then((res) => {
          if (res.data.status == 10000) {
            this.contentArr = res.data.data
          }
        })
      } else if (this.status == 'adding') {
        this.detail = {}
      }
      this.visible = val
    },
    getSystemList() {
      this.$axiosget('operation/dictionaryType/queryByKey', {
        params: {
          key: 'fireControlSystem'
        }
      }).then((res) => {
        if (res.data.status === '10000') {
          this.systemList = res.data.data ? res.data.data.list : []
        }
      })
    },
    getOpen() {
      this.$nextTick(() => {
        this.$refs.detail.clearValidate()
      })
    },
    selectSystem(e) {
      if (e) {
        this.$axiosget('extra/maintenanceContentItem/getListByFireSystem', {
          params: {
            fireControlSystem: e
          }
        }).then((res) => {
          if (res.data.status == 10000) {
            this.contentArr = res.data.data
          }
        })
        this.$set(this.detail, 'maintenanceContentId', undefined)
        this.$set(this.detail, 'maintenanceContentName', undefined)
      }
    },
    changeContent(e) {
      let obj = this.contentArr.find((item) => item.id == e)
      this.detail.maintenanceContentName = obj ? obj.patrolContent : ''
    },
    close() {
      this.detail = {}
      this.$nextTick(() => {
        this.$refs.detail.resetFields()
      })
    },
    cancel() {
      this.close()
      this.visible = false
    },
    confirm() {
      this.$refs.detail.validate((valid) => {
        if (valid) {
          if (this.status == 'adding') {
            this.$axiospost('extra/areaBuildingFacility', {
              ...this.detail,
              buildingId: this.selectBuilding.id
            }).then((res) => {
              if (res.data.status == 10000) {
                this.$message.success('添加成功')
                this.cancel()
                this.$emit('refresh')
              }
            })
          } else {
            this.$axiosput('extra/areaBuildingFacility', {
              maintenanceContentId: this.detail.maintenanceContentId,
              maintenanceContentName: this.detail.maintenanceContentName,
              fireControlSystem: this.detail.fireControlSystem,
              number: this.detail.number,
              id: this.detail.id
            }).then((res) => {
              if (res.data.status == 10000) {
                this.$message.success('编辑成功')
                this.cancel()
                this.$emit('refresh')
              }
            })
          }
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .el-form-item__content {
  margin-left: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/dynamicRoute3/management/buildingManage/buildManage/facilitiesDialog.vue